import { useLocation } from 'react-router-dom'

// Components
import NavLink from 'components/header/navlink'

import styles from './navlinks.css'

type Links = Array<{
  text: string
  url: string
  matchUrls?: Array<string>
  onlyLinksMobile?: boolean
  linksDefaultOpenMobile?: boolean
  loggedin_required?: 0 | 1
  links?: Array<{
    text: string
    url: string
  }>
  page_id?: number
}>

const links: Links = [
  {
    text: 'Tracks',
    url: '/inspiration/',
    matchUrls: ['/inspiration/', '/tracks/', '/collections/', '/genres/', '/artists/', '/labels/'],
    onlyLinksMobile: true,
    linksDefaultOpenMobile: true,
    links: [
      {
        text: 'Inspiration',
        url: '/inspiration/',
      },
      {
        text: 'All tracks',
        url: '/tracks/',
      },
      {
        text: 'Collections',
        url: '/collections/',
      },
      {
        text: 'Genres',
        url: '/genres/',
      },
      {
        text: 'Artists',
        url: '/artists/',
      },
      {
        text: 'Labels',
        url: '/labels/',
      },
    ],
  },
  {
    text: 'Your songs',
    url: '/yoursongs/',
    loggedin_required: 1,
  },
  {
    text: 'How it works',
    url: '/howitworks/',
    matchUrls: ['/howitworks/', '/plans/', '/howtouse/', '/music/', '/licensing/'],
    page_id: 58,
    links: [
      {
        text: 'Plans & pricing',
        url: '/plans/',
      },
      {
        text: 'How to use',
        url: '/howtouse/',
      },
      {
        text: 'Licensing',
        url: '/licensing/',
      },
      {
        text: 'Music catalog',
        url: '/music/',
      },
    ],
  },
  { text: 'Blog', url: '/blog/', page_id: 4 },
]

type NavLinksProps = {
  isAuthenticated: boolean
  compressed: boolean
  onLinkClick: () => void
}

const NavLinks = ({ isAuthenticated, compressed, onLinkClick }: NavLinksProps): JSX.Element => {
  const { pathname: activePath } = useLocation()
  return (
    <nav>
      <ul className={styles.links} datatesting="navmenu_links">
        {links.map(link => (
          <NavLink
            key={link.url}
            link={link}
            isAuthenticated={isAuthenticated}
            compressed={compressed}
            activePath={activePath}
            onLinkClick={onLinkClick}
            linksDefaultOpenMobile={link.linksDefaultOpenMobile}
          />
        ))}
      </ul>
    </nav>
  )
}

export default NavLinks
